import '../styles/fonts.css'
import '../styles/globals.css'

const MyApp = ({ Component, pageProps }) => {
    return <Component {...pageProps} />
}

export default MyApp
